// extracted by mini-css-extract-plugin
export default {"box":"Filter_box__2iRtJ","icon":"Filter_icon__BC3pU","input":"Filter_input__Xa1eH"};